module.exports = __webpack_public_path__ + "static/media/UserMen.feca79b4.svg";